<template>
    <div class="col-12">
        <kendo-datasource ref="venueDatasource"
                          :transport="venueTransportSettings"
                          :server-filtering="true"
                          :server-paging="false"
                          :schema-model-id="'placeId'"
                          :schema-model-fields="venueSchemaModel"
                          :error="dataSourceError"
                          :requestEnd="datasorceRequestEnd"
                          :typeof="'odata-v4'"></kendo-datasource>

        <kendo-datasource ref="hallsDatasource"
                          :transport="hallTransportSettingsOdata"
                          :filter="hallFilter"
                          :server-filtering="true"
                          :server-paging="false"
                          :schema-model-id="'hallId'"
                          :schema-model-fields="hallSchemaModel"
                          :error="dataSourceError"
                          :requestEnd="datasorceRequestEnd"
                          :typeof="'odata-v4'"></kendo-datasource>

        <div class="btn-toolbar justify-content-between mt-3" role="toolbar">
            <div class="form-inline col-lg-1 col-md-12">
                <div class="btn-group-vertical">
                    <button class="btn btn-link pt-0" id="addBtn" v-if="claims.agenda.create"
                            data-toggle="tooltip"
                            @click.stop="onCreateClick"
                            :title="$t('buttons.add.btnText')">
                        <i class="far fa-plus-square fa-3x text-primary"></i>
                    </button>
                </div>
            </div>

            <div class="input-group col-lg-11 col-md-12">
                <div class="row col-12">
                    <div class="col-lg-5 col-md-12">
                        <kendo-dropdownlist ref="venueDropdown"
                                            v-model="settings.placeId"
                                            :data-source-ref="'venueDatasource'"
                                            :data-text-field="'name'"
                                            :data-value-field="'placeId'"
                                            :filter="'contains'"
                                            :clear-button="true"
                                            :optionLabel="$t('choose')"
                                            :height="500"
                                            style="width:100%"
                                            aria-describedby="placeHelpBlock"
                                            @change="venueChanged">
                        </kendo-dropdownlist>
                        <small id="placeHelpBlock" class="form-text text-muted">{{ $t('scheduler.venue') }}</small>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <kendo-multiselect ref="hallsDropdown"
                                           v-model="settings.halls"
                                           :data-source-ref="'hallsDatasource'"
                                           :data-text-field="'name'"
                                           :data-value-field="'hallId'"
                                           :filter="'contains'"
                                           :clear-button="true"
                                           :name="'halls' + _uid"
                                           :placeholder="$t('choose')"
                                           :height="500"
                                           style="width: 100%;"
                                           aria-describedby="hallsHelpBlock">
                        </kendo-multiselect>
                        <small id="hallsHelpBlock" class="form-text text-muted">{{ $t('scheduler.hall') }}</small>
                    </div>
                    <div class="col-lg-1 col-md-12">
                        <div class="btn-group">
                            <button class="btn btn-link pt-0"
                                    @click.stop="saveSettings"
                                    data-toggle="tooltip"
                                    :disabled="saving"
                                    :title="$t('buttons.saveSettings.btnText')">
                                <i class="fas fa-save fa-3x text-secondary"></i>
                            </button>
                            <button class="btn btn-link pt-0"
                                    @click.stop="recreateScheduler"
                                    data-toggle="tooltip"
                                    :title="$t('buttons.reloadCalendar.btnText')">
                                <i class="fas fa-sync fa-3x text-secondary"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="clearfix"></div>

        <div class="col-12" id="hallScheduler"></div>

        <CreateModal :show="showCreate" @onCreate="onCreate" @onClose="onCreateClose"></CreateModal>
        <DetailsModal v-model="model" :show="showDetails" :allowEdit="false" @onClose="onDetailsClose"></DetailsModal>

    </div>
</template>

<script>
    import Vue from 'vue';
    import $ from 'jquery';
    import { SchedulerInstaller } from '@progress/kendo-scheduler-vue-wrapper';
    import { Culture } from '../../models/enums';
    import { ScheduleTask, SchedulerCalendarSettingsModel } from '../../models/models';
    // import HallEvent from '../../components/scheduler/HallEvent';
    import CreateModal from '../../components/scheduler/create.modal';
    import { mapGetters } from 'vuex';
    import agendaService from '../../services/agenda.service';
    import DetailsModal from '../../components/scheduler/details.modal';
    import personalizationService from '../../services/personalization.service'

    Vue.use(SchedulerInstaller);

    export default {
        components: {
            // HallEvent,
            CreateModal,
            DetailsModal
        },
        props: {
            viewType: {
                required: true,
                type: String
            },
            defaultPlaceId: {
                type: Number,
                default: 1004
            }
        },
        data() {
            return {
                name: 'HallEventCalendar',
                scheduleTask: null,
                initialDate: new Date(),
                settings: new SchedulerCalendarSettingsModel(),
                saving: false,
                showDetails: false,
                model: null,
                showCreate: false,
                dateHeaderTemplate: "'<strong>#=kendo.toString(date, 'yyyy-MMM-dd')#</strong>",
                startWorkingTime: new Date('2020/01/20 07:00 AM'), // Начален час на показване // new Date(this.initialDate.getFullYear(), this.initialDate.getMonth(), this.initialDate.getDate(), 7, 0, 0),
                endWorkingTime: new Date('2020/01/20 08:00 PM'), // Краен час на показване // new Date(this.initialDate.getFullYear(), this.initialDate.getMonth(), this.initialDate.getDate(), 7, 0, 0),
                allDaySlot: true,
                pdfExportFileName: 'Scheduler_Export.pdf',
                venueTransportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/hallScheduler/placeDropdownModels`,
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.odata4ParameterMap
                },
                hallTransportSettingsOdata: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/hallScheduler/hallDropdownSchedulerModelOdata`,
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.odata4ParameterMap
                },
                hallTransportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/hallScheduler/hallDropdownSchedulerModel`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                shedulerTransportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/hallScheduler/hallEventsList`,
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.odata4ParameterMap
                },
                venueSchemaModel: {
                    registerEntryId: { name: 'registerEntryId', from: 'registerEntryId', type: 'number', nullable: false },
                    placeId: { name: 'placeId', from: 'placeId', type: 'number', nullable: false },
                    name: { name: 'name', from: 'name', type: 'string', nullable: false }
                },
                hallSchemaModel: {
                    hallId: { name: 'hallId', from: 'hallId', type: 'number', nullable: false },
                    placeId: { name: 'placeId', from: 'placeId', type: 'number', nullable: true },
                    name: { name: 'name', from: 'name', type: 'string', nullable: true },
                    capacity: { name: 'capacity', from: 'capacity', type: 'number', nullable: true }
                },
                scheduleSchemaModelFields: {
                    id: { name: 'id', from: 'id', type: 'number' },
                    title: { name: 'title', from: 'title', defaultValue: 'Enter title', validation: { required: true } },
                    description: { name: 'description', from: 'description', type: 'string', nullable: true },
                    hallId: { name: 'hallId', from: 'hallId', type: 'number', nullable: true },
                    placeId: { name: 'placeId', from: 'placeId', type: 'number', nullable: true },
                    eventId: { name: 'eventId', from: 'eventId', type: 'number', nullable: true },
                    eventName: { name: 'eventName', from: 'eventName', type: 'string', nullable: true },
                    capacity: { name: 'capacity', from: 'capacity', type: 'number' },
                    start: { name: 'start', from: 'startTimeUtc', type: 'date' },
                    end: { name: 'end', from: 'endTimeUtc', type: 'date' },
                    isAllDay: { name: 'isAllDay', from: 'isAllDay', type: 'boolean' }
                },
                eventTemplate:
                    '<div><h4>#: title #</h4><h5>#: eventName #</h5><p>#: kendo.toString(start, "hh:mm") # - #: kendo.toString(end, "hh:mm") #</p></div>',
                group: {
                    resources: ['Halls']
                    // resources: ["Halls", "Lectors"],
                    // orientation: "vertical"
                },
                hallsDataSource: {
                    transport: {
                        read: {
                            url: this.$store.getters.baseUrl + `/api/hallScheduler/hallDropdownSchedulerModel`,
                            beforeSend: this.beforeSend
                        },
                        parameterMap: this.odata4ParameterMap
                    },
                    filter: this.hallFilter,
                    requestEnd: this.datasorceRequestEnd
                }
            };
        },
        methods: {
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            odata4ParameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) };
                } else {
                    const newOptions = kendo.data.transports['odata-v4'].parameterMap(options, operation);

                    return newOptions;
                }
            },
            parameterMap(options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) };
                } else {
                    let newOptions = { placeId: this.settings.placeId, request: options, halls: this.settings.halls };
                    return kendo.stringify(newOptions);
                }
            },
            datasorceRequestEnd(e) {
                if (e.type === 'read' && e.response) {
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration
                });
            },
            parseCalendarData(response) {
                /*
                Executed before the server response is used. Use it to preprocess or parse the server response

                PARAMETERS
                    response Object|Array
                        The initially parsed server response that may need additional modifications.

                RETURNS
                    Array—The data items from the response.
                */

                return response;
            },
            addAppointment() {
                this.scheduleTask = new ScheduleTask({ isInEditMode: true, expanded: true });
            },
            hallEventDeleted(item) {
                this.resetScheduleTask();
            },
            hallEventCanceled(item) {
                this.resetScheduleTask();
            },
            hallEventSaved(item) {
                this.resetScheduleTask();
            },
            resetScheduleTask() {
                this.scheduleTask = null;
            },
            onCreateClick() {
                if (this.details) {
                    return;
                }
                this.showCreate = true;
            },
            onCreateClose() {
                this.showCreate = false;
            },
            onCreate(model) {
                this.recreateScheduler();
            },
            recreateScheduler() {
                var ele = $('#hallScheduler');
                var scheduler = ele.data('kendoScheduler');
                if (scheduler) {
                    scheduler.destroy();
                    ele.html('');
                }

                $('#hallScheduler').kendoScheduler({
                    date: this.initialDate,
                    startTime: this.startWorkingTime,
                    endTime: this.endWorkingTime,
                    allDaySlot: this.allDaySlot,
                    editable: false,
                    mobile: true,
                    group: this.group,
                    ref: 'hallScheduler',
                    toolbar: [],
                    pdf: {
                        fileName: this.pdfExportFileName
                    },
                    views: [
                        { type: 'day', selected: this.viewType === 'day' },
                        { type: 'workWeek', selected: this.viewType === 'workWeek' },
                        { type: 'week', selected: this.viewType === 'week' },
                        { type: 'month', selected: this.viewType === 'month' },
                        { type: 'agenda', selected: this.viewType === 'agenda' }
                    ],
                    eventTemplate: this.eventTemplate,
                    allDayEvenTemplate: this.eventTemplate,
                    dataSource: {
                        transport: this.shedulerTransportSettings,
                        serverFiltering: true,
                        schema: {
                            model: {
                                id: 'id',
                                fields: this.scheduleSchemaModelFields
                            },
                            parse: this.parseCalendarData,
                        },
                        typeof: 'odata-v4',
                        error: this.dataSourceError,
                        requestEnd: this.datasorceRequestEnd
                    },
                    resources: [
                        {
                            field: 'hallId',
                            name: 'Halls',
                            title: 'Hall',
                            dataColorField: 'key',
                            dataSource: {
                                // transport: this.hallTransportSettingsOdata,
                                transport: this.hallTransportSettings,
                                serverFiltering: true,
                                serverPaging: false,
                                schema: {
                                    model: {
                                        id: 'id',
                                        fields: this.hallSchemaModel
                                    }
                                },
                                filter: this.hallFilter,
                                error: this.dataSourceError,
                                requestEnd: this.datasorceRequestEnd
                            }
                        }
                    ]
                });
            },
            eventDoubleClicked(e) {
                var scheduler = $("#hallScheduler").data("kendoScheduler");
                if (!scheduler) {
                    return;
                }

                var element = $(e.target).is(".k-event") ? $(e.target) : $(e.target).closest(".k-event");
                var item = scheduler.occurrenceByUid(element.data("uid"));
                if (item.id) {
                    this.showDetailsClick(item.id);
                }
            },
            showDetailsClick(id) {
                if (!this.hasReadRights) {
                    return
                }

                agendaService
                    .getById(id)
                    .then(response => {
                        this.model = response.data.model;
                        this.showDetails = true;
                    })
                    .catch(error => {
                        this.model = null;
                        this.showDetails = false;

                        this.$vs.notify({
                            title: this.componentTitle + ' - ' + this.$t('request.response.status.' + statusCode),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.notificationColor(statusCode),
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            onDetailsClose() {
                this.model = null;
                this.showDetails = false;
            },
            clearSource() {
                if (Array.isArray(this.settings.halls)) {
                    while (this.settings.halls.length > 0) {
                        this.settings.halls.pop();
                    }
                }
            },
            loadSettings() {
                return new Promise((resolve, reject) => {
                    this.clearSource();

                    personalizationService
                        .loadSchedulerCalendarUserSettings()
                        .then(response => {
                            if (response.data.settings) {
                                if (Array.isArray(response.data.settings.halls)
                                    && response.data.settings.halls.length > 0) {
                                    response.data.settings.halls.forEach(id => {
                                        // не работи както трябва
                                        // this.settings.halls.push(id)
                                    })
                                }

                                this.settings.placeId = response.data.settings.placeId
                            }

                            this.$emit('reloaded');
                            resolve(true);
                        })
                        .catch(error => {
                            this.settings = new SchedulerCalendarSettingsModel();
                            this.$emit('reloaded');

                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: 'danger',
                                time: this.$store.getters.notificationDuration
                            });

                            reject(error);
                        });
                })
            },
            saveSettings() {
                this.saving = true;

                personalizationService
                    .saveSchedulerCalendarUserSettings(this.settings)
                    .then(response => {
                        this.saving = false;
                        this.$emit('reloaded');

                        this.$vs.notify({
                            title: this.$t('buttons.saveGridOptions.btnText'),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    })
                    .catch(error => {
                        this.saving = false;
                        this.$emit('reloaded');

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            venueChanged(e) {
                // this.resetHallsDropdown()
            },
            resetHallsDropdown() {
                const hallsDropdown = this.$refs.hallsDropdown;
                if (hallsDropdown) {
                    hallsDropdown.kendoWidget().value([])
                    // hallsDropdown.kendoWidget().trigger('change')
                }
            }
        },
        mounted() {
            this.loadSettings().then(() => {
                if (!this.settings.placeId) {
                    this.settings.placeId = this.defaultPlaceId;
                }
            });

            // add listener to a scheduler item doubl click
            $("#hallScheduler").on('dblclick', '.k-event', this.eventDoubleClicked);
        },
        beforeDestroy() {
            // remove hallScheduler
            $("#scheduler").off('dblclick', '.k-event');
        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            hallFilter() {
                let val = Number(this.settings.placeId);
                if (!isNaN(val) && val > 0) {
                    return {
                        logic: 'and',
                        filters: [
                            {
                                field: 'PlaceId',
                                operator: 'eq',
                                value: val
                            }
                        ]
                    };
                } else {
                    return {}
                }
            },
            hasEditRights() {
                return this.$store.getters.claims.agenda.create || this.$store.getters.claims.agenda.update;
            },
            hasReadRights() {
                return this.$store.getters.claims.agenda.read;
            },
            ...mapGetters(['claims'])
        },
        watch: {
            'settings.placeId': function (val) {
                let num = Number(val);
                if (isNaN(num) || num <= 0) {
                    return;
                }
                this.recreateScheduler();
            },
            'settings.halls': function (val) {
                this.recreateScheduler();
            }
        }
    };
</script>

<style scoped>
    .invalid-slot {
        background: red !important;
        cursor: no-drop;
    }

    /* Hide toolbar, navigation and footer during export */
    .k-pdf-export .k-scheduler-toolbar,
    .k-pdf-export .k-scheduler-navigation .k-nav-today,
    .k-pdf-export .k-scheduler-navigation .k-nav-prev,
    .k-pdf-export .k-scheduler-navigation .k-nav-next,
    .k-pdf-export .k-scheduler-footer {
        display: none;
    }
</style>
